import { render, staticRenderFns } from "./EventDocuments.vue?vue&type=template&id=3f620a78&scoped=true&"
import script from "./EventDocuments.vue?vue&type=script&lang=js&"
export * from "./EventDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EventDocuments.vue?vue&type=style&index=0&id=3f620a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f620a78",
  null
  
)

export default component.exports